<h3>{{ 'login.welcomeBack' | translate }} {{ user.firstName }}!</h3>

<div class="d-flex flex-column p-3 points">
  <h3 class="m-0">{{ 'user.user-my-profile.loyalty_benefits_rewards' | translate }}</h3>
  <span class="mt-2 mb-4">{{ 'user.user-my-profile.loyalty_description' | translate }}</span>

  <table class="loyalty-table">
    <thead>
      <tr>
        <th>{{ 'user.user-my-profile.loyalty_card_number' | translate | uppercase }}</th>
        <th class="red-note">{{ 'user.user-my-profile.loyalty_card_expiry_date' | translate | uppercase }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="font-size: 1.5rem">{{ findLoyaltyCard()?.number ?? '...' }}</td>
        <td style="font-size: 1.5rem" class="red-note">{{ findLoyaltyCard()?.expiryDate | date: 'dd.MM.yyyy' }}</td>
      </tr>
      <tr>
        <td colspan="2">&nbsp;</td>
      </tr>
      <tr>
        <th>{{ 'user.user-my-profile.loyalty_points' | translate | uppercase }}</th>
        <th>{{ 'user.user-my-profile.collected_points' | translate | uppercase }}</th>
      </tr>
      <tr>
        <td style="font-size: 1.5rem">{{ findLoyaltyCard()?.pointsBalance ?? '...' }}</td>
        <td style="font-size: 1.5rem">{{ findLoyaltyCard()?.collectedPoints ?? '...' }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="mt-5">
  <app-user-upcoming [accountItems]="accountItems"></app-user-upcoming>
</div>

<div class="mt-5 mb-5">
  <app-account-items [title]="'user.user-my-profile.accountItemsTitle' | translate"
                     [availableTypes]="['voucher', 'card']" (itemChangeState)="useItem($event)">
  </app-account-items>
</div>

<app-user-loyalty-popups></app-user-loyalty-popups>